import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface DashboardSidebarStoreState {
  isDataforseo: boolean;
  setIsDataforseo: (isDataforseo: boolean | ((isDataforseo: boolean) => boolean)) => void;
}

export const useDashboardSidebarStore = create(
  devtools<DashboardSidebarStoreState>((set) => ({
    isDataforseo: false,
    setIsDataforseo: (isDataforseo) =>
      set((state) => {
        if (typeof isDataforseo === 'function') {
          return {
            isDataforseo: isDataforseo(state.isDataforseo),
          };
        }
        return {
          isDataforseo,
        };
      }),
  })),
);
